import { PROJECT_NAME } from 'src/constants';

const LabelStandard = () => {
  return (
    <label
      className="nj-label-free nj-label-standard"
      data-e2e="label-tier-standard"
    >
      {`${PROJECT_NAME} Standard`}
    </label>
  );
};

export default LabelStandard;
